angular.module('LeasePilot').factory('FormService', [
  'railsResourceFactory',
  function(railsResourceFactory) {
    return railsResourceFactory({
      url: '/api/forms',
      name: 'form',
    });
  },
]);
